import React, { useState } from 'react'
import AppSidebar from '../../../components/AppSidebar'
import AppHeader from '../../../components/AppHeader'
import PageHeader from '../../../components/PageHeader'
import { Link } from 'react-router-dom'
import  ViewProposalModal  from './modals/ViewProposalModal'
import { MdVisibility } from "react-icons/md";

const ListProposal = () => {
    const [showViewProposalModal, setShowViewProposalModal] = useState(false)
    const handleClose = () => {
        setShowViewProposalModal(false)
    }
    const openModal = () => {
        setShowViewProposalModal(true)
    }
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <PageHeader title="Proposals" className="btn btn-sm btn-primary" link_to="/proposals/create" button_title="Create" button_label="Create" />
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="list" role="tabpanel" aria-labelledby="list-tab">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <form>
                                                    <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                        <input className="form-control list-search" type="search" placeholder="Search" />
                                                        <div className="input-group-text">
                                                            <span className="fe fe-search"></span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="col-auto ">
                                                <form>
                                                    <select className="form-select form-select-sm form-control-flush" data-choices='{"searchEnabled": false}'>
                                                        <option>5 per page</option>
                                                        <option>10 per page</option>
                                                        <option>All</option>
                                                    </select>
                                                </form>
                                            </div>
                                            <div className="col-auto me-n3">
                                                <div className="dropdown">
                                                    <button className="btn btn-sm btn-white" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                                                        <i className="fe fe-sliders me-1"></i> Filter <span className="badge bg-primary ms-1">1</span>
                                                    </button>
                                                    <form className="dropdown-menu dropdown-menu-end dropdown-menu-card">
                                                        <div className="card-header">
                                                            <h4 className="card-header-title">
                                                                Filters
                                                            </h4>
                                                            <button className="btn btn-sm btn-link text-reset" type="reset">
                                                                <small>Clear filters</small>
                                                            </button>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="list-group list-group-flush mt-n4 mb-4">
                                                                <div className="list-group-item">
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <small>Title</small>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <select className="form-select form-select-sm" name="item-title" data-choices='{"searchEnabled": false}'>
                                                                                <option value="*">Any</option>
                                                                                <option value="Designer">Designer</option>
                                                                                <option value="Developer">Developer</option>
                                                                                <option value="Owner">Owner</option>
                                                                                <option value="Founder">Founder</option>
                                                                            </select>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="list-group-item">
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <small>Lead scrore</small>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <select className="form-select form-select-sm" name="item-score" data-choices='{"searchEnabled": false}'>
                                                                                <option value="*">Any</option>
                                                                                <option value="1/10">1+</option>
                                                                                <option value="2/10">2+</option>
                                                                                <option value="3/10">3+</option>
                                                                                <option value="4/10">4+</option>
                                                                                <option value="5/10">5+</option>
                                                                                <option value="6/10">6+</option>
                                                                                <option value="7/10">7+</option>
                                                                                <option value="8/10">8+</option>
                                                                                <option value="9/10">9+</option>
                                                                                <option value="10/10">10</option>
                                                                            </select>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button className="btn w-100 btn-primary" type="submit">
                                                                Apply filter
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-sm table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Proposal #</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Subject</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">To</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Total</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Date</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Open Till</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Status</Link>
                                                                    </th>
                                                                    <th>
                                                                        <Link className="list-sort text-body-secondary" data-sort="item-name">Date Created</Link>
                                                                    </th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="row">9589133100</th>
                                                                    <td><Link to="#" onClick={() => openModal(1)}>Mark</Link></td>
                                                                    <td>Otto</td>
                                                                    <td>@mdo</td>
                                                                    <td>Mark</td>
                                                                    <td>Mark</td>
                                                                    <td>Mark</td>
                                                                    <td>Mark</td>
                                                                    <td>
                                                                       <Link to="/proposals/:id/view" title='View'  target="_blank" rel="noopener noreferrer"><MdVisibility /></Link>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showViewProposalModal &&
                <ViewProposalModal
                    show={showViewProposalModal}
                    handleClose={handleClose}
                />
            }
        </>
    )
}

export default ListProposal